export default "__VITE_ASSET__DLp_jXn7__"